import angular from 'angular';
import { IStateProvider } from 'angular-ui-router';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

angular.module('flowingly.runner.publicsop').config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider: IStateProvider): void {
  $stateProvider.state(STATE_MAPPINGS.publicSop, {
    url: '/sop/{id}',
    params: {
      title: 'SOP'
    },
    controller: 'runnerPublicSopController',
    controllerAs: '$ctrl',
    templateUrl: 'Client/runner.publicsop/runner.publicsop.tmpl.html'
  });
}
